import { ATDLNParameterType } from "../enums/atdl-parameter-type.enum";

export const PARAM_TO_FIX_MAPPING = new Map<ATDLNParameterType, number>([
  [ATDLNParameterType.AMT, 10],
  [ATDLNParameterType.ANY_URI, -1],
  [ATDLNParameterType.BOOLEAN_FIX, 13],
  [ATDLNParameterType.BOOLEAN_XML, -1],
  [ATDLNParameterType.BORDER, -1],
  [ATDLNParameterType.CHAR, 12],
  [ATDLNParameterType.COUNTRY, 25],
  [ATDLNParameterType.CURRENCY, 16],
  [ATDLNParameterType.DECIMAL, -1],
  [ATDLNParameterType.FLOAT, 6],
  [ATDLNParameterType.EXCHANGE, 17],
  [ATDLNParameterType.INT, 1],
  [ATDLNParameterType.LANGUAGE, 26],
  [ATDLNParameterType.LENGTH, 2],
  [ATDLNParameterType.LOCALMKTTZ, -1],
  [ATDLNParameterType.MONTHYEAR, 18],
  [ATDLNParameterType.MULTICHAR, 15],
  [ATDLNParameterType.MULTISTRING, 24],
  [ATDLNParameterType.ORIENTATION, -1],
  [ATDLNParameterType.PERCENT, 11],
  [ATDLNParameterType.TAGNUM, 3],
  [ATDLNParameterType.NUMGROUP, 5],
  [ATDLNParameterType.POSINT, -1],
  [ATDLNParameterType.PRICE, 8],
  [ATDLNParameterType.PRICE_OFFSET, 9],
  [ATDLNParameterType.QTY, 7],
  [ATDLNParameterType.SEQNUM, 4],
  [ATDLNParameterType.STRING, 14],
  [ATDLNParameterType.STRINGID, -1],
  [ATDLNParameterType.TIME, -1],
  [ATDLNParameterType.DATE, 21],
  [ATDLNParameterType.TZTIMESTAMP, 28],
  [ATDLNParameterType.TZTIMEONLY, 27],
  [ATDLNParameterType.TENOR, 29],
  [ATDLNParameterType.UTCDATEONLY, 22],
  [ATDLNParameterType.UTCTIMEONLY, 20],
  [ATDLNParameterType.UTCTIMESTAMP, 19],
]);

/**
 * Maps the input FIX type to our internal Enum type
 */
export const FIX_TO_PARAM_MAPPING = new Map<number, ATDLNParameterType>([
  [1, ATDLNParameterType.INT],
  [2, ATDLNParameterType.LENGTH],
  [3, ATDLNParameterType.TAGNUM],
  [4, ATDLNParameterType.SEQNUM],
  [5, ATDLNParameterType.NUMGROUP],
  [6, ATDLNParameterType.FLOAT],
  [7, ATDLNParameterType.QTY],
  [8, ATDLNParameterType.PRICE],
  [9, ATDLNParameterType.PRICE_OFFSET],
  [10, ATDLNParameterType.AMT],
  [11, ATDLNParameterType.PERCENT],
  [12, ATDLNParameterType.CHAR],
  [13, ATDLNParameterType.BOOLEAN_FIX],
  [14, ATDLNParameterType.STRING],
  [15, ATDLNParameterType.MULTICHAR],
  [16, ATDLNParameterType.CURRENCY],
  [17, ATDLNParameterType.EXCHANGE],
  [18, ATDLNParameterType.MONTHYEAR],
  [19, ATDLNParameterType.UTCTIMESTAMP],
  [20, ATDLNParameterType.UTCTIMEONLY],
  [21, ATDLNParameterType.DATE],
  [22, ATDLNParameterType.UTCDATEONLY],
  [24, ATDLNParameterType.MULTISTRING],
  [25, ATDLNParameterType.COUNTRY],
  [26, ATDLNParameterType.LANGUAGE],
  [27, ATDLNParameterType.TZTIMEONLY],
  [28, ATDLNParameterType.TZTIMESTAMP],
  [29, ATDLNParameterType.TENOR],
]);

/* export const PARAM_TO_CONFIG_MAPPING = new Map<ATDLNControlType, Array<ATDLNParameterType>>([
	[ATDLNControlType.CHECKBOX_T, [ATDLNParameterType.BOOLEAN_T,
								ATDLNParameterType.STRING_T,
								ATDLNParameterType.CHAR_T]],
	[ATDLNControlType.CLOCK_T, [ATDLNParameterType.UTCTIMEONLY_T]],								
	[ATDLNControlType.DROPDOWNBOX_T, [ATDLNParameterType.ENUM]],
	[ATDLNControlType.LABEL_T, [ATDLNParameterType.STRING_T]],
	[ATDLNControlType.RADIOBUTTONLIST_T, [ATDLNParameterType.ENUM]],
	[ATDLNControlType.SINGLESPINNER_T, [ATDLNParameterType.AMT_T,
										ATDLNParameterType.FLOAT_T,
										ATDLNParameterType.INT_T,
										ATDLNParameterType.PERCENTAGE_T,
										ATDLNParameterType.PRICE_T,
										ATDLNParameterType.PRICEOFFSET_T,
										ATDLNParameterType.QTY_T,]],
	[ATDLNControlType.TEXTFIELD_T, [ATDLNParameterType.STRING_T, 
									ATDLNParameterType.CHAR_T]],
]); */
